export const topCatcy = () => {
  $(document).ready(function () {
    setTimeout(function () {
      $(".js-fade-up-catcy").addClass("is-show");
    }, 1000);
  });
};
